export default {
    props: {
      value: {
        type: [String, Number],
        default: ""
      },
      ariaLabel: {
        type: String,
        required: false
      },
      ariaLabelledby: {
        type: String,
        required: false
      },
      disabled: {
        type: Boolean,
        required: false,
        default: false
      },
      tabindex: {
        type: [String, Number],
        required: false,
        default: 0
      }
    },
  
    computed: {
      listenersWithoutInput() {
        const others = { ...this.$listeners }
        delete others.input
        return others
      }
    }
}
